import React from "react";
import BrandsCarousel from "./BrandsCarousel";
import Deals from "./Deals";
import Recommended from "./Recommended";
import NewsLetter from "../../NewsLetter/NewsLetter";
import NewlyAddedStores from "./NewlyAddedStores";
import MostTrendingStore from "./MostTrendingStore";
import HomeBanner from "./HomeBanner.jsx";

function Index({ history, match }) {
  return (
    <div>
      <HomeBanner />
      <BrandsCarousel />
      <MostTrendingStore />
      <Recommended />
      <Deals history={history} match={match} />
      <NewlyAddedStores />
      <NewsLetter />
    </div>
  );
}

export default Index;
